import paymentErc20 from "@/lib/eth/ethCall/paymentErc20";
import proposalFactory from './proposalFactory'
import storeFactory from './storeFactory'

export default {
    paymentErc20,
    proposalFactory,
    storeFactory
}